export enum ProjectStatus {
  Geplant = 0,
  Aktiv = 1,
  Pausiert = 2,
  Abgeschlossen = 3,
  Abgebrochen = 4
}

export enum ProjectPriority {
  Niedrig = 0,
  Mittel = 1,
  Hoch = 2,
  Kritisch = 3
}

export interface Project {
  projectID: number;
  mandantID: number;
  mandantName: string;
  name: string;
  beschreibung?: string;
  beginDatum: string;
  endDatum?: string;
  status: ProjectStatus;
  prioritaet: ProjectPriority;
  farbe?: string;
  budget?: number;
  istKosten?: number;
  erstelltAm: string;
  geaendertAm: string;
  archiviert: boolean;

  // Statistiken
  anzahlDokumente: number;
  anzahlTickets: number;
  anzahlMails: number;
  anzahlAdressen: number;
  anzahlTeamMitglieder: number;

  // Optional: Details für Detailansicht
  dokumente?: ProjectDocument[];
  tickets?: ProjectTicket[];
  mails?: ProjectMail[];
  adressen?: ProjectAddress[];
  teamMitglieder?: ProjectUser[];
}

export interface ProjectCreateDto {
  mandantID: number;
  name: string;
  beschreibung?: string;
  beginDatum: string;
  endDatum?: string;
  status?: ProjectStatus;
  prioritaet?: ProjectPriority;
  farbe?: string;
  budget?: number;
}

export interface ProjectUpdateDto {
  name: string;
  beschreibung?: string;
  beginDatum: string;
  endDatum?: string;
  status: ProjectStatus;
  prioritaet: ProjectPriority;
  farbe?: string;
  budget?: number;
  istKosten?: number;
  archiviert: boolean;
}

export interface ProjectDocument {
  id: number;
  dokumentID: number;
  documentName: string;
  zugeordnetAm: string;
}

export interface ProjectTicket {
  id: number;
  ticketID: number;
  ticketTitle: string;
  zugeordnetAm: string;
}

export interface ProjectMail {
  id: number;
  emailID: number;
  mailSubject: string;
  zugeordnetAm: string;
}

export interface ProjectAddress {
  id: number;
  adresseID: number;
  addressName: string;
  rolle?: string;
  zugeordnetAm: string;
}

export interface ProjectUser {
  id: number;
  benutzerID: number;
  userName: string;
  rolle?: string;
  zugeordnetAm: string;
}

export interface AssignToProjectDto {
  projectID: number;
  itemID: number;
  rolle?: string;
}

export const ProjectStatusLabels: Record<ProjectStatus, string> = {
  [ProjectStatus.Geplant]: 'Geplant',
  [ProjectStatus.Aktiv]: 'Aktiv',
  [ProjectStatus.Pausiert]: 'Pausiert',
  [ProjectStatus.Abgeschlossen]: 'Abgeschlossen',
  [ProjectStatus.Abgebrochen]: 'Abgebrochen'
};

export const ProjectPriorityLabels: Record<ProjectPriority, string> = {
  [ProjectPriority.Niedrig]: 'Niedrig',
  [ProjectPriority.Mittel]: 'Mittel',
  [ProjectPriority.Hoch]: 'Hoch',
  [ProjectPriority.Kritisch]: 'Kritisch'
};

export const ProjectStatusColors: Record<ProjectStatus, string> = {
  [ProjectStatus.Geplant]: 'blue',
  [ProjectStatus.Aktiv]: 'green',
  [ProjectStatus.Pausiert]: 'orange',
  [ProjectStatus.Abgeschlossen]: 'gray',
  [ProjectStatus.Abgebrochen]: 'red'
};

export const ProjectPriorityColors: Record<ProjectPriority, string> = {
  [ProjectPriority.Niedrig]: 'green',
  [ProjectPriority.Mittel]: 'blue',
  [ProjectPriority.Hoch]: 'orange',
  [ProjectPriority.Kritisch]: 'red'
};
